import type { AccountType } from '../types/account.js';

// Display labels for AccountType. Used by the Campaign Visibility
// section, Campaign list "Assigned to" column, and the AccountTreePicker
// option labels — three surfaces previously each carrying their own
// inline map.

export const ACCOUNT_TYPE_LABEL: Record<AccountType, string> = {
  brand: 'Brand',
  group: 'Group',
  location: 'Location',
  head_office: 'Head Office',
  region: 'Region',
  dealership: 'Dealership',
};

// Sort key for the order in which a Campaign's share targets are
// summarised on the Campaign list. Brand-shared first (most common),
// then group-shared (organisational), then location-shared (specific),
// with the long tail of structural types last. Within a tier callers
// sort alphabetically by Account name.
const SORT_RANK: Record<AccountType, number> = {
  brand: 0,
  group: 1,
  region: 2,
  head_office: 3,
  dealership: 4,
  location: 5,
};

export function compareAccountTypeForSummary(a: AccountType, b: AccountType): number {
  return SORT_RANK[a] - SORT_RANK[b];
}
